import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddUserAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 126,
	height: 126,
	viewBox: "0 0 126 126",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 63,
			cy: 63,
			r: 63,
			fill: "#EEEEF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.3872 99.151V91.1174C92.3872 86.8561 90.6945 82.7694 87.6813 79.7562C84.6681 76.7431 80.5814 75.0503 76.3201 75.0503H52.2195C47.9582 75.0503 43.8715 76.7431 40.8583 79.7562C37.8451 82.7694 36.1523 86.8561 36.1523 91.1174V99.151",
			stroke: "white",
			strokeWidth: 8.45638,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.2702 58.9831C73.1439 58.9831 80.3374 51.7896 80.3374 42.916C80.3374 34.0424 73.1439 26.8489 64.2702 26.8489C55.3966 26.8489 48.2031 34.0424 48.2031 42.916C48.2031 51.7896 55.3966 58.9831 64.2702 58.9831Z",
			stroke: "white",
			strokeWidth: 8.45638,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAddUserAvatar;
